// extracted by css-extract-rspack-plugin
export default {"root":"mCpZwM","expanded-grid":"rnkbbr","expandedGrid":"rnkbbr"};